import dialogManager from "./dialogManager.png";
import menu from "./menu.png";
import stats from "./stats.png";
import items from "./items.png";
import shop from "./shop.png";
import battleManager from "./battleManager.png";
import attackEffect from "./attackEffect.png";
import selectTarget from "./selectTarget.png";
import selectMagic from "./selectMagic.png";
import battleNotification from "./battleNotification.png";
import battleRewards from "./battleRewards.png";
import gameOver from "./gameOver.png";
import gamePlay from "./adventureStory.mp4";

let images = {
    dialogManager: dialogManager,
    menu: menu,
    stats: stats,
    items: items,
    shop: shop,
    battleManager: battleManager,
    attackEffect: attackEffect,
    selectTarget: selectTarget,
    selectMagic: selectMagic,
    battleNotification: battleNotification,
    battleRewards: battleRewards,
    gameOver: gameOver,
    gamePlay: gamePlay
};

export default images;